<template>
	<div ref="popupContainer">
		<vs-popup
			:title="'Google Seach Console Requête de ' + society.name"
			:active.sync="popupActive"
			style="z-index: 999991"
		>
			<!-- Batch Delete Confirmation Popup -->
			<!-- <vs-popup
				title="Êtes-vous sûr de vouloir supprimer ?"
				:active.sync="batchDeleteConfirmationPopup"
				style="z-index: 999991"
			>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2">
						<vs-button class="mt-2 w-full" @click="removeKeywordBatch()"
							>Oui</vs-button
						>
					</div>
					<div class="vx-col sm:w-1/2">
						<vs-button
							class="mt-2 w-full"
							@click="batchDeleteConfirmationPopup = false"
						>
							Non</vs-button
						>
					</div>
				</div>
			</vs-popup> -->
			<!-- Single Delete Confirmation Popup -->
			<!-- <vs-popup
				title="Êtes-vous sûr de vouloir supprimer ?"
				:active.sync="deleteConfirmationPopup"
				style="z-index: 999991"
			>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2">
						<vs-button
							class="mt-2 w-full"
							@click="removeKeyword(selectedKeywordId)"
							>Oui</vs-button
						>
					</div>
					<div class="vx-col sm:w-1/2">
						<vs-button
							class="mt-2 w-full"
							@click="deleteConfirmationPopup = false"
						>
							Non</vs-button
						>
					</div>
				</div>
			</vs-popup> -->
			<div class="vx-row mt-4" v-if="gscOverview">
				<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
					<vx-tooltip
						title="Impressions"
						text="Nombre de fois où votre site a été affiché(e) dans les résultats de recherche."
						position="top"
					>
						<statistics-card-line
							hideChart
							class="mb-base Impressions pointer"
							style="box-shadow: 0px 0px 10px 2px #28c76f"
							icon="ServerIcon"
							icon-right
							:statistic="
								gscOverview.impressions == 0
									? 0
									: formatThousandNumb(gscOverview.impressions)
							"
							statisticTitle="Impressions"
							color="success"
						/>
					</vx-tooltip>
				</div>

				<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
					<vx-tooltip
						title="Clics"
						text="Nombre de clics sur votre site par un moteur de recherche."
						position="top"
					>
						<statistics-card-line
							hideChart
							class="mb-base Clics pointer"
							style="box-shadow: 0px 0px 10px 2px #7367f0"
							icon="CpuIcon"
							colorTo="primary"
							icon-right
							:statistic="
								gscOverview.clicks == 0
									? 0
									: formatThousandNumb(gscOverview.clicks)
							"
							statisticTitle="Clics"
						/>
					</vx-tooltip>
				</div>

				<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
					<vx-tooltip
						title="CTR"
						text="Pourcentage de clics par rapport au nombre d'impressions."
						position="top"
					>
						<statistics-card-line
							hideChart
							class="mb-base CTR pointer"
							style="box-shadow: 0px 0px 10px 2px #ea5455"
							icon="ActivityIcon"
							colorTo="primary"
							icon-right
							:statistic="formatValue(gscOverview.ctr, 2) + '%'"
							statisticTitle="CTR"
							color="danger"
						/>
					</vx-tooltip>
				</div>

				<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
					<vx-tooltip
						title="Position Moyenne"
						text="Position moyenne sur le mois."
						position="top"
					>
						<statistics-card-line
							hideChart
							class="mb-base Position pointer"
							style="box-shadow: 0px 0px 10px 2px #ff9f43"
							icon="AlertOctagonIcon"
							icon-right
							:statistic="formatValue(gscOverview.position, 0)"
							statisticTitle="Position Moyenne"
							color="warning"
						/>
					</vx-tooltip>
				</div>
			</div>
			<div>
				<div v-if="isLoading" class="text-center">
					<circular-loader />
				</div>
				<div v-else>
					<div class="keyword-editor">
						<!-- Keyword Table -->
						<vs-table
							pagination
							max-items="100"
							search
							:data="queries"
							:key="refreshTableKey"
						>
							<template slot="thead">
								<vs-th style="pointer-events: auto" sort-key="isTopKeyword"
									>Top Keyword</vs-th
								>
								<vs-th style="pointer-events: auto" sort-key="query"
									>Requête</vs-th
								>
								<vs-th style="pointer-events: auto" sort-key="impressions"
									>Impressions</vs-th
								>
								<vs-th style="pointer-events: auto" sort-key="clicks"
									>Clics</vs-th
								>

								<vs-th style="pointer-events: auto" sort-key="ctr">CTR</vs-th>
								<vs-th style="pointer-events: auto" sort-key="averagePosition"
									>Position Moyenne</vs-th
								>
								<vs-th style="pointer-events: auto" sort-key="lastPosition"
									>Derniere Position</vs-th
								>
								<vs-th style="pointer-events: auto" sort-key="potential"
									>Potential</vs-th
								>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>
										<div class="flex items-center">
											<div class="flex items-center">
												<vs-icon
													v-if="data[indextr].isTopKeyword"
													icon="star"
													color="warning"
													size="small"
													class="ml-2"
													@click="onToogleTopKeyword(data[indextr])"
												></vs-icon>
												<vs-icon
													v-else
													icon="star"
													color="grey"
													size="small"
													class="ml-2"
													@click="onToogleTopKeyword(data[indextr])"
												></vs-icon>
											</div>
											<div class="flex items-center">
												<vs-icon
													v-if="data[indextr].isBrand"
													icon="business"
													color="warning"
													size="small"
													class="ml-2"
													@click="onToogleBrand(data[indextr])"
												></vs-icon>
												<vs-icon
													v-else
													icon="business"
													color="grey"
													size="small"
													class="ml-2"
													@click="onToogleBrand(data[indextr])"
												></vs-icon>
											</div>
										</div>
									</vs-td>
									<!-- Query -->
									<vs-td :data="data[indextr].query">
										<div>{{ data[indextr].query }}</div>
									</vs-td>
									<!-- Impressions -->
									<vs-td :data="data[indextr].impressions" class="text-right">
										<div>{{ data[indextr].impressions }}</div>
									</vs-td>

									<!-- Clicks -->
									<vs-td :data="data[indextr].clicks" class="text-right">
										<div>{{ data[indextr].clicks }}</div>
									</vs-td>

									<!-- CTR -->
									<vs-td :data="data[indextr].ctr" class="text-right">
										<div>{{ data[indextr].ctr }}</div>
									</vs-td>

									<!-- Position -->
									<vs-td
										:data="data[indextr].averagePosition"
										class="text-right"
									>
										<div>{{ data[indextr].averagePosition }}</div>
									</vs-td>
									<vs-td :data="data[indextr].lastPosition" class="text-right">
										<div>{{ data[indextr].lastPosition }}</div>
									</vs-td>
									<vs-td :data="data[indextr].potential" class="text-right">
										<div>
											{{ data[indextr].potential }}
										</div>
									</vs-td>

									<!-- Is Top Keyword -->
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>
  
<script>
import Vue from "vue";
import XLSX from "xlsx";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import KeywordCategoriesPopup from "./KeywordCategoriesPopup.vue";
import VxTooltip from "../widgets/vx-tooltip/VxTooltip.vue";
import GSC from "../../entities/GSC";
import StatisticsCardLine from "../views/dashboard/statistics-cards/StatisticsCardLine.vue";
import utilsMixin from "@/mixins/utilsMixin";
import chartsMixin from "@/mixins/chartsMixin";
import Keywords from "../../entities/Keywords";
import Society from "../../entities/Society";

export default {
	components: {
		CircularLoader,
		KeywordCategoriesPopup,
		VxTooltip,
		StatisticsCardLine,
	},
	name: "GSCQueriesPopup",
	props: {
		society: {
			type: Object,
			required: true,
		},
		popupActive: {
			type: Boolean,
			required: true,
		},
	},
	mixins: [utilsMixin, chartsMixin],
	data() {
		return {
			isLoading: true,
			topQueries: [],
			gscOverview: [],
			refreshTableKey: 0,
		};
	},
	async created() {
		// Clone initial data and track max ID
		await this.getOverview();
		await this.getQueries();
	},
	computed: {},
	watch: {},
	methods: {
		async getQueries() {
			try {
				this.isLoading = true;
				console.log("Fetching queries for society:", this.society);
				const response = await GSC.getQueries(
					this.society.gsc_url,
					this.society.id
				);
				this.queries = response;
			} catch (error) {
				console.error("Error fetching queries:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de la récupération des requêtes. Peut-être que le site n'est pas authorisé ?",
					color: "danger",
					icon: "warning",
				});
			} finally {
				this.isLoading = false;
			}
		},
		async getOverview() {
			try {
				const response = await GSC.getOverview(
					this.society.gsc_url,
					this.society.id
				);
				this.gscOverview = response;
			} catch (error) {
				console.error("Error fetching queries:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de la récupération des requêtes. Peut-être que le site n'est pas authorisé ?",
					color: "danger",
					icon: "warning",
				});
			}
		},
		formatPercentage(value) {
			return (value * 100).toFixed(2) + "%";
		},

		async onToogleTopKeyword(queryBody) {
			try {
				if (queryBody.isTopKeyword) {
					await Keywords.deleteTopKeywordsByName(
						queryBody.query,
						this.society.id
					);
				} else {
					const body = {
						society_id: this.society.id || null,
						keyword: queryBody.query.trim(),
						comment: "",
						category_pairs: null,
						search_lang: "fr-fr",
						search_location: "Paris,Paris,Ile-de-France,France",
						search_engine: "google",
						isEditing: false,
					};
					await Keywords.addTopKeywords([body], this.society.id);
				}
				// Update the local state to reflect the change
				queryBody.isTopKeyword = !queryBody.isTopKeyword;
				this.refreshTableKey++;
				this.$vs.notify({
					title: "Succès",
					text: "Requête mise à jour avec succès.",
					color: "success",
					icon: "check",
				});
			} catch (error) {
				console.error("Error toggling top keyword:", error);
				this.$vs.notify({
					title: "Erreur",
					text: "Erreur lors de la mise à jour de la requête.",
					color: "danger",
					icon: "warning",
				});
			}
		},
		onToogleBrand(queryBody) {
			try {
				if (queryBody.isBrand) {
					Society.deleteBrandByName(queryBody.query, this.society.id);
				} else {
					const body = {
						society_id: this.society.id || null,
						brand: queryBody.query.trim(),
						comment: "",
						isFav: false,
						active: 1,
						isEditing: false,
					};
					Society.addBrands([body], this.society.id);
				}
				queryBody.isBrand = !queryBody.isBrand;
				this.refreshTableKey++;
				this.$vs.notify({
					title: "Succès",
					text: "Requête mise à jour avec succès.",
					color: "success",
					icon: "check",
				});
			} catch (error) {
				console.error("Error toggling brand keyword:", error);
			}
		},
	},
};
</script>
  
<style scoped>
</style>